import Button from "../../../../common/components/atom/Button/Button";
import TextInput from "../../../../common/components/atom/TextInput/TextInput";
import MessageCard from "../../../../common/components/molecule/MessageCard/MessageCard";

import styles from "./ResetPasswordUserFormView.module.scss";
import {
  ErrorStatusResetPassword,
  FormDataResetPassword,
} from "./ResetPawsswordUserForm";

export interface NewOrganizationFormViewProps {
  formData?: FormDataResetPassword;
  setFormData: (key: keyof FormDataResetPassword, value: string) => void;
  errorStatus?: ErrorStatusResetPassword;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
}

export const ResetPasswordUserFormView = ({
  handleSubmit,
  messageError,
  errorStatus,
  isLoading,
  submitLabel = "Modifier votre mots de passe",
  description = "",
  maxWidth = "700px",
  title,
  formData,
  setFormData,
}: NewOrganizationFormViewProps) => {
  return (
    <div style={{ maxWidth: maxWidth }}>
      <div className={[styles["container"]].join(" ")}>
        {title && (
          <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
        )}
        <p className={[styles["container__description"]].join(" ")}>
          {description}
        </p>
        <div className={[styles["container__error-message"]].join(" ")}>
          <MessageCard variant="danger" message={messageError} width100 />
        </div>
        <form
          className={[styles["form"]].join(" ")}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit && handleSubmit();
          }}
        >
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Nouveau mot de passe"
              value={formData?.password}
              error={errorStatus?.isErrorPassword}
              onChange={(e) => {
                setFormData("password", e.target.value);
              }}
              type="password"
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Nouveau mot de passe (confirmation)"
              value={formData?.confirmPassword}
              error={errorStatus?.isErrorConfirmPassword}
              onChange={(e) => {
                setFormData("confirmPassword", e.target.value);
              }}
              type="password"
           
            />
          </div>

          <div className={[styles["form__button-container"]].join(" ")}>
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                isLoading={isLoading}
                onClick={handleSubmit}
                type={"submit"}
              >
                {submitLabel}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
